export enum Permission {
  // Directory level.
  Directory_AccessAsUser_All = 'Directory.AccessAsUser.All', // Access directory as the signed-in user.
}

export type Permissions = Permission[];

export const AllPermissions = Object.values(Permission);
